import {fromJS} from 'immutable';
// types
import DesignTypes from '~/constants/types/DesignTypes';

export function initialState() {
  return fromJS({
    shareResponse: null
  });
}

export default function shareResponse(state = initialState(), action) {
  switch (action.type) {
    case DesignTypes.SHARE:
      return state.set('shareResponse', null);
    case DesignTypes.SHARE_SUCCESS: {
      const response = action.payload.success;
      return state.set('shareResponse', response);
    }
    case DesignTypes.SHARE_FAILURE: {
      const fieldErrors = {
        senderNameError: null,
        emailBodyError: null,
        recipientsError: null
      };
      fieldErrors.recipientsError = action.payload.message;
      return state.set('shareResponse', {fieldErrors});
    }
    case DesignTypes.SHARE_ERROR: {
      const serverError = action.payload.message;
      return state.set('shareResponse', {serverError});
    }
    default:
      return state;
  }
}
